export const Config = {
  // API_BASE_PATH: "http://localhost:8000/",
  // API_BASE_PATH_HWS: "http://localhost:8000/",
  API_BASE_PATH: "/wollemiAPI/",
  API_BASE_PATH_HWS: "/wollemiAPIHWS/",
  APPOINTMENT_FORM: "user/appointment",
  FAQ_FORM: "user/faq",
  RAISE_ISSUE_LOGIN: "user/raiseIssueApi",
  RAISE_AN_ISSUE: "manavAPI/raiseIssueApi/raiseAnIssue",

  //LOGIN-SCREEN
  CHECK_IP_LOGIN: "user/ipLogin",
  LOGIN: "user/login",
  RESET_PASSWORD_SUBMIT: "manavAPI/resetPassword/resetPasswordSubmit",
  FORGET_PASSWORD: "user/forgetPassword/forgetPasswordEmail",
  FORGET_PASSWORD_POLICY: "user/forgetPassword/forgetPasswordReset",
  FORGET_PASSWORD_SUBMIT: "user/forgetPassword/forgetPasswordResetSubmit",
  GET_IP_ADDRESS_URL: "user/userIp",

  //OUTLOOK-INTEGRATION
  OUTLOOK: "manavAPI/outLook/token",
  UPDATE_OUTLOOK: "manavAPI/outLook/updateOutlook",

  //COOKIES MAINTAIN
  COOKIES_MANAGE: "manavAPI/poc/updateCookies",

  //NAVIGATION
  HANDLE_NAVIGATION_STATUS: "manavAPI/navigation/saveNavigationDetail",
  CREATE_DOCUMENT: "manavAPI/export/createDocument",
  CREATE_EXCEL: "manavAPI/export/createExcel",
  CREATE_OPPO_PROFILE: "manavAPI/export/createOppProfile",
  DOCUMENT_CREATE_DB:`manavAPI/export/createDocumentFromUI`,
  EXPORT_EXCEL_DATA: `manavAPI/export/createExcelScouting`,
  EXPORT_RELEVANCE_DATA: "manavAPI/export/createExcelRelevance",
  CREATE_DOCUMENT_SCOUTING: "manavAPI/export/createDocumentScouting",
  CREATE_DOCUMENT_RELEVANCE: "manavAPI/export/createDocumentRelevance",

  //NOTIFICATIONS
  NOTIFICATION: "manavAPI/notification/getNotification",
  UPDATE_NOTIFICATION_STATUS: "manavAPI/notification/updateNotification",
  SINGLE_NOTIFICATION_INFO: "manavAPI/notification/getSingleNotification",
  BLOCK_ACTIVATION: "manavAPI/project/updateBlockSize",

  //USER-PROFILE
  RESET_CREDENTIALS: "manavAPI/user/resetCredentials",
  USER_PROFILE_INFO: "manavAPI/userProfile/getUserProfile",
  TECHNICAL_SUPPORT: "manavAPI/user/technicalSupport",
  TECHNICAL_SUPPORT_BEFORE_LOGIN: "user/technicalSupportBeforeLogin",

  //PROJECTS-DASHBOARD
  PROJECTS_LIST: "manavAPI/project/projectsList",
  PROJECTS_DELETE: "manavAPI/project/projectsDelete",
  REPLICATE_PROJECT: "manavAPI/project/replicate",

  //CREATE-PROJECT
  CREATE_PROJECT_LISTS: "manavAPI/project/createProjectLists",
  CREATE_PROJECT_SUBMIT: "manavAPI/project/createProjectSubmit",
  UPDATE_PROJECT: "manavAPI/project/updateProject",
  READ_PROJECT_LISTS: "manavAPI/project/createProjectReadable",

  //COST-CENTER
  COST_CENTER_DETAIL: "manavAPI/project/addNewCostCenter",
  COST_CENTER_SUBMIT: "manavAPI/project/addNewCostCenterSubmit",

  //UPLOAD TEMPLATE
  UPLOAD_TEMPLATE_LISTS: "manavAPI/template/uploadTemplate",
  UPLOAD_TEMPLATE_SUBMIT: "manavAPI/template/uploadTemplateSubmit",

  //QUERY-BUILDER
  QUERY_INPUT: "manavAPI/queryBuilder/queryBuilderInput",
  QUERY_INPUT_UNIQUE: "manavAPI/queryBuilder/queryBuilderInputUnique",
  QUERY_SINGLEHEAD: "manavAPI/queryBuilder/querySingleHead",
  QUERY_TREE_STRUCTURE: "manavAPI/queryBuilder/getTreeData",
  MULTIPLE_TREE_STRUCTURES: "manavAPI/queryBuilder/getTreeForMultipleValues",
  QUERY_CATEGORY: "manavAPI/queryBuilder/missingCategoryCheck",
  QUERY_SUBMIT: "manavAPI/queryBuilder/queryInputSubmit",
  DISCARD_QUERY: "manavAPI/queryBuilder/discardQuery",
  ACTIVE_INACTIVE_DATA: "manavAPI/queryBuilder/activeInactiveData",
  SEARCH_HEAD_VALUE: "manavAPI/queryBuilder/headSearchValue",
  DID_YOU_MEAN: "manavAPI/queryBuilder/didYouMean",

  //SCOUTING
  GET_SCOUTING_DETAILS:
    "manavAPI/scoutingQueryBuilder/getScoutingQueryBuilderDetails",
  SAVE_SCOUTING_DETAILS:
    "manavAPI/scoutingQueryBuilder/saveScoutingQueryBuilderDetails",
  MODULE_3_SCOUTING_DETAILS:
    "manavAPI/scoutingPlayerGrid/displayScoutingUserData",
  SAVE_SCOUTING_WEIGHTAGE:
    "manavAPI/scoutingPlayerGrid/saveScoutingLeadDetailsWeightages",
  RESET_SCOUTING_WEIGHTAGE:
    "manavAPI/scoutingPlayerGrid/resetScoutingLeadDetailsWeightages",
  SELECT_OPPORTUNITY: "manavAPI/scoutingPlayerGrid/selectOpportunity",
  DESELECT_OPPORTUNITY: "manavAPI/scoutingPlayerGrid/deselectOpportunity",
  SAVE_OPPORTUNITY: "manavAPI/scoutingPlayerGrid/saveOpportunity",
  UNSAVE_OPPORTUNITIES_SCOUTING:
    "manavAPI/scoutingPlayerGrid/unsaveOpportunity",
  SAVED_OPPORTUNITIES: "manavAPI/scoutingPlayerGrid/savedOpportunities",
  VALUE_MATRIX_SCOUTING: "manavAPI/scoutingValueMatrix/getValueMatrixData",
  SCOUTING_MY_COLLECTION_SAVED_OPPORTUNITIES:
    "manavAPI/scoutingProjectFiles/getSavedOpportunities",
  DEEP_SCOUTING_SEARCH: "manavAPI/scoutingPlayerGrid/deepSearch",
  REQUEST_DEEP_ANALYSIS:
    "manavAPI/scoutingPlayerGrid/requestForDetailAnalaysis",
  RELEVANCE_SCOUTING: "manavAPI/scoutingPlayerGrid/scoutingRelevenceData",
  SCOUTING_GRAPH_PAGELOAD: "manavAPI/scoutingPlayerGrid/scoutingGraphPageLoad",
  SCOUTING_GRAPH: "manavAPI/scoutingPlayerGrid/scoutingGraph",

  //QUERY-VALIDATION
  QUERY_VALIDATION: "manavAPI/queryBuilder/validation",
  QUERY_CONFLICTS: "manavAPI/queryBuilder/validationSubmit",

  //FEASIBILITY
  NEED_LICENSE_FEASIBILITY:
    "manavAPI/licenseFeasibility/needLicenseFeasibility",
  NEED_LICENSE_FEASIBILITY_SUBMIT:
    "manavAPI/licenseFeasibility/needLicenceFeasibilitySubmit",
  RESEARCH_LEAD_REQUEST: "manavAPI/licenseFeasibility/requestForResearchLead",
  MANUFACTURER_REQUEST_PLAYER:
    "manavAPI/licenseFeasibility/requestForManufacturersDevelopment",
  CONFIRMATORY_ASSESSMENT:
    "manavAPI/licenseFeasibility/requestForConfirmatoryAssessment",

  //COMPETITORS
  COMPETITORS_LIST: "manavAPI/licenseFeasibility/competitorsList",
  COMPETITORS_LIST_SUBMIT: "manavAPI/licenseFeasibility/competitorsListSubmit",

  //ADJACENCY
  OPTIMIZATION_PAGE_LOAD: "manavAPI/optimization/optimizationData",
  SAVED_SUGGESTIONS: "manavAPI/optimization/savedSuggestions",
  DISTANT_SUGGESTION: "manavAPI/optimization/distantSuggestions",
  SAVE_SUGGESTION: "manavAPI/optimization/saveSuggestions",
  DISTANT_PROCEED: "manavAPI/optimization/saveDistantSuggestions",
  PROCEED_OPTIMIZATION: "manavAPI/optimization/proceedOptimization",
  NP_REGISTRATION_CHECK: "manavAPI/optimization/saveNpRegistrationCheck",

  //TRADE-OFF
  TRADEOFF_PAGE_LOAD: "manavAPI/tradeoff/tradeOffPageLoad",
  TRADEOFF_PROCEED: "manavAPI/tradeoff/proceedTradeOff",
  REQUEST_TRADE_OFF: "manavAPI/tradeoff/requestTradeOff",

  //COMPLEXITY
  COMPLEXITY_PAGELOAD: "manavAPI/complexity/complexityData",

  //PLAYER-GRID
  PRODUCT_MAIN_SCREEN: "manavAPI/poc/getPOCData",
  SAVE_PLAYERS: "manavAPI/poc/savePlayers",
  SAVED_PLAYERS: "manavAPI/poc/savedPlayers",
  FILTERED_PLAYERS: "manavAPI/poc/filteredPlayers",
  FAMILARITY_PLAYERS: "manavAPI/poc/playerFamilarity",
  MARK_COMPETITOR: "manavAPI/poc/markCompetitor",
  SELECTION_DESELECTION: "manavAPI/poc/selectionDeselection",
  GET_SAVED_OPPORTUNITIES: "manavAPI/poc/getSavedOpportunities",
  GET_SAVED_OPPORTUNITIES_MODULE3: "manavAPI/poc/getUserSavedOpportunities",
  SAVE_OPPORTUNITIES: "manavAPI/poc/saveOpportunities",
  UNSAVE_OPPORTUNITIES: "manavAPI/poc/unsaveOpportunities",
  GET_FILTERS: "manavAPI/poc/getAdvancedFilters",
  //OPPORTUNITY- DATA
  OPPORTUNITY_DATA: "manavAPI/poc/getOpportunityComparatorHeadsList",
  OPPORTUNITIES_COMPARISON: "manavAPI/poc/getOpportunityComparatorData",
  RESET_WEIGHTAGES_OPPORTUNITY: "manavAPI/poc/resetOpportunityWeightages",
  SAVE_WEIGHTAGES_OPPORTUNITY: "manavAPI/poc/saveOpportunityWeightages",
  SAVE_FILTERS_FROM_OPPORTUNITY: "manavAPI/poc/saveOpportunityFilters",

  //OPTIMIZER-SCREEN
  RELEVANCE_OPTIMIZER_PAGE_LOAD: "manavAPI/poc/optimizerData",
  RESET_WEIGHTAGES: "manavAPI/poc/resetWeightages",
  SAVE_WEIGHTAGES: "manavAPI/poc/saveWeightages",

  //PRODUCT-LEVEL
  PRODUCT_LEVEL_COMPARISON: "manavAPI/poc/productsData",
  RESET_PRODUCT_LEVEL_WEIGHTAGES: "manavAPI/poc/resetProductWeightages",
  SAVE_PRODUCT_LEVEL_WEIGHTAGES: "manavAPI/poc/saveProductWeightages",
  SAVE_PRODUCTS: "manavAPI/poc/saveProducts",
  REFRESH_PLAYERS: "manavAPI/poc/refreshPOCData",

  //PLAYER PROFILE
  PLAYER_PROFILE_PAGE_LOAD: "manavAPI/poc/playerProfileData",

  //PRODUCT PROFILE
  PRODUCT_PROFILE_PAGE_LOAD: "manavAPI/poc/productProfileData",

  POC_TO_BE_UNSAVED: "manavAPI/poc/pocToBeRemoved",
  SELECTED_POC: "manavAPI/poc/selectedPocData",

  //CONTRACT-MIS
  GET_CONTRACTS_LIST: "manavAPI/myCollection/contractsList",
  CONTRACT_MIS: "manavAPI/myCollection/projectsSummary",
  CONTRACT_MIS_FILTER: "manavAPI/myCollection/filteredProjectsSummary",

  //PROJECT-DETAIL
  PROJECT_DETAIL: "manavAPI/myCollection/getProjectDetail",
  SELECTED_PLAYERS_COLLECTION: "manavAPI/myCollection/selectedPlayers",
  FINALIZED_NEED_COLLECTION: "manavAPI/myCollection/finalNeed",
  FAME_INDEX_COLLECTION: "manavAPI/licenseFeasibility/needLicenseFeasibility",
  TEAM_MEMBERS_COLLECTION: "manavAPI/myCollection/teamMembers",
  NOTIFICATIONS_COLLECTION: "manavAPI/myCollection/notifications",
  TEAM_NOTES_COLLECTION: "manavAPI/myCollection/teamNotes",
  AVAILABLE_USERS_COLLECTION: "manavAPI/myCollection/newUsers",
  REMOVE_TEAM_MEMBER: "manavAPI/myCollection/removeTeamMember",
  ADD_TEAM_MEMBERS: "manavAPI/myCollection/addTeamMembers",

  //TEAM-ASSESSMENT
  PAGELOAD_TEAM_ASSESSMENT: "manavAPI/myCollection/getTeamAssessment",
  SAVE_TEAM_ASSESSMENT: "manavAPI/myCollection/submitTeamAssessment",

  TOP_FIVE_PLAYER: "manavAPI/myCollection/getTopFivePlayer",
  OTHER_RATING: "manavAPI/myCollection/getOtherRating",

  //MANAGEMENT-SUMMARY
  GET_MANAGEMENT_SUMMARY: "manavAPI/myCollection/getManagementSummary",
  TOTAL_EXPENSE_DATA: "manavAPI/myCollection/totalExpenseData",
  GET_RATIO_DATA: "manavAPI/myCollection/getParticularRatioData",
  REMOVE_USER_FROM_SUMMARY: "manavAPI/myCollection/removeContractUser",
  ADD_USER_FROM_SUMMARY: "manavAPI/myCollection/addContractUser",
  TRIGGER_INVOICE: "manavAPI/myCollection/triggerInvoice",
  GET_USER_EDIT_DETAIL: "manavAPI/myCollection/getUserDetail",
  UPDATE_USER: "manavAPI/myCollection/updateContractUser",

  //IP-MAPPING
  GET_IP_MAPPING_DETAIL: "manavAPI/myCollection/requestIPData",
  GET_IP_MAPPING_PLAYERS: "manavAPI/myCollection/requestSelectedPlayer",
  IP_REQUEST: "manavAPI/myCollection/requestForIp",
  IP_REQUEST_OPPORTUNITY: "manavAPI/myCollection/requestForOpportunityIp",

  //PLAYER-CONNECT
  UPLOAD_PLAYERS_CONNECT_DOC: "manavAPI/myCollection/addPartnerDoc",
  PLAYERS_CONNECT: "manavAPI/myCollection/addPartners",
  GET_PARTNERS_TO_CONNECT: "manavAPI/myCollection/requestSelectedPlayerConnect",
  GET_PARTNERS_OUTCOME: "manavAPI/myCollection/getDataPlayerConnect",
  ADD_REMARK_PARTNER_CONNECT: "manavAPI/myCollection/addRemark",

  RESEARCH_REQUEST: "manavAPI/myCollection/requestForResearchOpportunity",
  MANUFACTURER_REQUEST:
    "manavAPI/myCollection/requestForManufactureOpportunity",

  //scientific assessment
  SCIENTIFIC_ASSESSMENT_REQUEST:
    "manavAPI/myCollection/requestForScientificAssessment",
  SCIENTIFIC_ASSESSMENT_DATA:
    "manavAPI/myCollection/requestScientificAssessmentData",
  SCIENTIFIC_ASSESSMENT_AVAILABLE_PLAYERS:
    "manavAPI/myCollection/getScientificAssessmentAvailablePlayers",
  SCIENTIFIC_ASSESSMENT_REQUEST_OPPORTUNITY:
    "manavAPI/myCollection/requestForScientificOpportunity",

  //PROJECTS-COMPARISON
  PROJECTS_COMPARISON: "manavAPI/myCollection/projectCompare",

  //VAULT
  CHECK_DEFAULT_CAPTURE: "manavAPI/vault/existingData",
  ADD_TO_VAULT: "manavAPI/vault/addToVault",
  GET_VAULT_ITEMS: "manavAPI/vault/getVaultItems",
  SHUFFLED_TILES: "manavAPI/vault/shuffleTiles",
  FILTERED_VAULT: "manavAPI/vault/getFilteredVaultItems",
  HIDE_VAULT_TILE: "manavAPI/vault/hideVaultTile",
  RENAME_VAULT_TILE: "manavAPI/vault/renameVaultTile",
  GET_PARTICULAR_TILE_DATA: "manavAPI/vault/getTileData",
  GET_DEFAULT_CAPTURED: "manavAPI/vault/getDefaultCaptured",
  UPLOAD_IMAGE_VAULT: "manavAPI/vault/uploadImage",
  BUILD_VAULT: "manavAPI/vault/buildVault",
  REPLACE_ADD_ORIGINAL_CAPTURED_VAULT:
    "manavAPI/vault/replaceOrAddToOriginalVault",
  UPDATE_NOTE: "manavAPI/vault/updateVaultNotes",
  CREATE_PPT: "manavAPI/vault/createPPT",
  USER_DETAIL_PPT: "manavAPI/vault/userDetailForPpt",
  DELETE_SLIDE: "manavAPI/vault/deleteSlide",

  //PRICING
  GET_PRICING: "manavAPI/contractTopUp/getTopUpPricing",
  PRICE_CONSENT: "manavAPI/contractTopUp/proceedTopUpPriceConsent",

  GET_PARTNER_RELATED_INFO: "manavAPI/myCollection/getPartnerData",

  RESEARCH_LEAD_DATA: "manavAPI/myCollection/getResearchLeadData",
  SAVE_RESEARCH_LEAD_PLAYERS: "manavAPI/myCollection/saveResearchLeadPlayers",
  UNSAVE_RESEARCH_LEAD_PLAYERS:
    "manavAPI/myCollection/unsaveResearchLeadPlayers",

  MANUFACTURER_LEAD_DATA: "manavAPI/myCollection/getManufacturerLeadData",
  SAVE_MANUFACTURER_LEAD_PLAYERS:
    "manavAPI/myCollection/saveManufacturerLeadPlayers",
  UNSAVE_MANUFACTURER_LEAD_PLAYERS:
    "manavAPI/myCollection/unsaveManufacturerLeadPlayers",

  //insights
  LOAD_PROJECTDETAIL_FILTERS: "manavAPI/insights/getprojectDetailAndFilters",
  LOAD_INSIGHT_RAW_DATA: "manavAPI/insights/getInsightsGraphsData",

  REGULATORY_DATA: "manavAPI/insights/regulatoryData",
  INNOVATION_GRAPH: "manavAPI/insights/getInnovationIntensityData",
  DIFFERENTIATION_GRAPH: "manavAPI/insights/getDifferentiationData",
  PORTFOLIO_GRAPH: "manavAPI/insights/getPortfolioData",
  VALUE_MATRIX_GRAPH: "manavAPI/insights/getValueMatrixData",

  FORMAT_GRAPH: "manavAPI/insights/getFormatData",
  BENEFIT_GRAPH: "manavAPI/insights/getBenefitData",
  FRESHNESS_INDEX_GRAPH: "manavAPI/insights/getFreshnessData",
  DEMOGRAPHICS_GRAPH: "manavAPI/insights/getDemographicsData",
  REGU_GRAPH: "manavAPI/insights/getRegulatoryData",
  POSITIONING_GRAPH: "manavAPI/insights/getPositioningData",
  GEO_GRAPH: "manavAPI/insights/getGeoData",
  ECO_SYSTEM: "manavAPI/insights/getEcoData",
  SAVE_SCOPE_PRECISION: "manavAPI/optimization/saveScopePrecision",

  RESEARCH_OUTCOME_OPP: "manavAPI/myCollection/getResearchOpportunityData",
  MANUFACTURE_OUTCOME_OPP:
    "manavAPI/myCollection/getManufacturerOpportunityData",
  IP_OUTCOME_OPP: "manavAPI/myCollection/requestOpportunityIPData",
  SCIENTIFIC_OUTCOME_OPP:
    "manavAPI/myCollection/requestScientificOpportunityData",

  GET_STRATEGIC_QUERY_DETAILS:
    "manavAPI/strategicQueryBuilder/getStrategicQueryBuilderDetails", //Strategic Assessment
  SAVE_STRATEGIC_QUERY_DETAILS:
    "manavAPI/strategicQueryBuilder/saveStrategicQueryBuilderDetails",
  STRATEGIC_MODULE3_HOME: "manavAPI/strategicValueMatrix/getValueMatrixData",
  STRATEGIC_OPPORTUNITY_COMPARATOR:
    "manavAPI/strategicValueMatrix/getOpportunityComparatorData",
  STRATEGIC_OPPORTUNITY_PROFILE:
    "manavAPI/strategicValueMatrix/getOpportunityProfile",
  SAVE_STRATEGIC_WEIGHTAGE:
    "manavAPI/strategicValueMatrix/saveStrategicParameterWeightages",
  RESET_STRATEGIC_WEIGHTAGE:
    "manavAPI/strategicValueMatrix/resetStrategicParameterWeightages",
  SAVE_STRATEGIC_OPPORTUNITY: "manavAPI/strategicValueMatrix/saveOpportunity",
  UNSAVE_STRATEGIC_OPPORTUNITY:
    "manavAPI/strategicValueMatrix/unsaveOpportunity",
  SAVED_STRATEGIC_OPPORTUNITY:
    "manavAPI/strategicValueMatrix/savedOpportunities",
  SAVED_STRATEGIC_OPPORTUNITIES_COLLECTION:
    "manavAPI/strategicProjectFiles/getSavedOpportunities",
  ASSESSMENT_METHODOLOGY:
    "manavAPI/strategicValueMatrix/getAssessmentMethodology",

  LANDSCAPE_MODULE_3_HOME: "manavAPI/externalScanAPI/getExternalScanData", //Landscape
  LANDSCAPE_FAMILIARITY_DATA:
    "manavAPI/externalScanAPI/getExistingAssetBrandFamiliarityData",
  GET_MARKET_DATA: "manavAPI/queryBuilder/getExternalScanOtherMarketList",

  FORMULA_CHECKER_RESULT_COUNT:
    "manavAPI/formulaCheckerApi/getNumberOfCountForReference",
  FORMULA_CHECKER_OUTCOME:
    "manavAPI/formulaCheckerApi/getOutcomeDataForReference",
  FORMULA_CHECKER_SORTING: "manavAPI/formulaCheckerApi/getDataAfterSorting",
  QUERY_FORMULA: "manavAPI/formulaCheckerApi/getFormulaQuery",
  FORMULA_CHECKER_EXCEL: "manavAPI/export/createFormulaExcel",
  ROLL_OUT_BRANDLIST: "manavAPI/formulaCheckerApi/getBrandList",
  ROLL_OUT_OUTCOME: "manavAPI/formulaCheckerApi/outcomeForWatchoutAndRollout",
  ROLL_OUT_EXCEL: "manavAPI/export/createRollOutExcel",
  ROLL_OUT_DOC: "manavAPI/export/createRollOutDoc",
  REGUATORY_EXCEL: "manavAPI/export/createRegulatoryExcel",

  ADHOC_PAGE_LOAD: "manavAPI/adHocAPI/getDataOnPageLoad",
  ADHOC_QUERY_SUBMIT: "manavAPI/adHocAPI/saveAdHocQueryBuilderDetails",
  ADHOC_SAVE_Query: "manavAPI/adHocAPI/requestForAssessment",
  REQUEST_RESEARCH_ASSESSMENT: "manavAPI/adHocAPI/requestForAssessment",

  PRODUCT_GRAPH: "manavAPI/insights/allProductGraphs",
  RECOMMENDATION_GRAPH: "manavAPI/insights/allRecommGraphs",

  //Consumer need
  CONSUMER_QUERY_INPUT: "manavAPI/consumerNeed/getQueryDetails",
  CONSUMER_SAVE_QUERY: "manavAPI/consumerNeed/saveQueryDetails",
  CONSUMER_GET_LISTS: "manavAPI/consumerNeed/getUniqueList",
  CONSUMER_REVIEW_DATA: "manavAPI/consumerNeed/getReviewData",
  CONSUMER_SOCIAL_DATA: "manavAPI/consumerNeed/getSocialData",
  CONSUMER_BRANDS: "manavAPI/consumerNeed/brandAndWebAnalytics",
  CONSUMER_NEED: "manavAPI/consumerNeed/consumerNeed",
  CONSUMER_TRIGGERS: "manavAPI/consumerNeed/triggers",
  CONSUMER_TRENDS: "manavAPI/consumerNeed/trends",
  CONSUMER_AGE: "manavAPI/consumerNeed/age",
  CONSUMER_GENDER: "manavAPI/consumerNeed/gender",
  CONSUMER_WORD_ART: "manavAPI/consumerNeed/wordArt",
  CONSUMER_ON_GO: "manavAPI/consumerNeed/onGo",
  CONSUMER_GET_FILTERS: "manavAPI/consumerNeed/getFilters",
  CONSUMER_EXPORT: "manavAPI/export/createConsumerExcel",
  CONSUMER_UPDATE_ONGO: "manavAPI/consumerNeed/updateOntheGo",
  WORD_ART_SUMMARY: "manavAPI/consumerNeed/wordSummary",
  CHAT_BOT: "manavAPI/chatBot/getAnswers",
  CHAT_BOT_RESET: "manavAPI/chatBot/resetChat",
  CHAT_BOT_PREVIOUS: "manavAPI/chatBot/previousChat",

  //HWS
  GET_HWS_DETAILS: "manavAPI/hws/get-hws-details",
  SAVE_HWS_DETAILS: "manavAPI/hws/submit-hws-details",
  HWS_PAGELOAD: "manavAPI/hws/onPageLoad",
  HWS1_SPELL_CHECK: "manavAPI/hws/spellChecker",
  HWS_LIST: "manavAPI/hws/getHwsList",
  HWS_ON_GO: "manavAPI/hwsOutcome/onGo",
  HWS_REPORT: "manavAPI/hwsOutcome/getHwsOutcome",
  HWS_UPDATE_ONGO: "manavAPI/hwsOutcome/updateOntheGo",
  HWS_GRAPH_PAGELOAD: "manavAPI/hwsOutcome/hwsGraphPageLoad",
  HWS_GRAPH: "manavAPI/hwsOutcome/hwsGraph",
  HWS_CREATE_EXCEL: "manavAPI/export/createExcelHws",
  CREATE_PDF_DOCUMENT: "manavAPI/export/createPdfDocument",

  SAVE_LOG: "logoFile/save-log",
};
